import { render, staticRenderFns } from "./EmailDropdown.vue?vue&type=template&id=0a5ef11b&scoped=true&"
import script from "./EmailDropdown.vue?vue&type=script&lang=js&"
export * from "./EmailDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EmailDropdown.vue?vue&type=style&index=0&id=0a5ef11b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5ef11b",
  null
  
)

export default component.exports